var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 85,
    viewBox: "0 0 76 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8101 0.887688C16.1415 2.2217 12.9399 4.95642 10.8722 8.49155C9.27136 11.2263 9.00456 12.3602 9.00456 16.9625C9.00456 21.5649 9.27136 22.6988 10.8722 25.4335C17.8757 37.3062 35.7515 36.3057 41.0208 23.6993C42.4215 20.3642 42.4215 13.5608 41.0208 10.2258C37.7525 2.3551 27.8808 -1.98044 19.8101 0.887688Z",
    fill: "#164D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00305 38.7736C3.80193 39.9075 2.60132 41.1081 1.53411 43.3092C0.0667006 46.1106 0 47.0444 0 60.6513C0 76.7929 0.533604 79.0607 4.73574 82.0622C6.93686 83.5963 7.33706 83.663 22.945 83.8631L38.8197 84.0632L34.8844 80.3947C22.7449 69.189 23.0784 51.2466 35.6181 40.3077L39.0198 37.3061H23.9455C9.73828 37.3061 8.80447 37.3728 6.00305 38.7736Z",
    fill: "#164D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6242 37.973C40.554 39.4404 34.6843 44.2428 31.5494 50.9796C30.0153 54.3813 29.7485 55.8487 29.8152 60.6512C29.8152 64.1196 30.2821 67.4546 30.9491 69.2555C35.3513 81.1949 48.558 86.7311 61.698 82.2622C66.3671 80.6613 72.0366 74.9251 73.9042 69.7891C75.6384 65.1201 75.8385 57.8497 74.3711 52.7805C71.2362 42.3085 59.03 35.5718 47.6242 37.973ZM64.5662 54.0478C64.7663 55.115 49.6919 68.6552 48.2912 68.6552C47.3574 68.6552 40.6874 60.7846 40.6874 59.6507C40.6874 57.3161 42.4216 57.9164 45.4231 61.2515L48.6247 64.8533L55.4949 58.7836C62.1649 52.9139 64.0993 51.8467 64.5662 54.0478Z",
    fill: "#164D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.b09aa759846023d600d7146a136b51e5.svg";
export { ForwardRef as ReactComponent };